var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.fromMyConsole ? "我的主控台" : "獎勵應用中心") + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 justify-content-between align-items-center"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-auto mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-auto d-flex flex-wrap"
  }, [_vm.$permissions.has(_vm.consts.REDEEM_CODE_USED_LIST_VIEW) ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "link",
      "to": {
        name: 'BelongedRedeemCodeList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _vm._v("優惠券使用紀錄 ")]) : _vm._e(), _vm.canCreateRedeemCodeBundle ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增優惠券 ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex flex-wrap align-items-center mb-2"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "160px",
      "height": "35px",
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "options": _vm.validityStatusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.is_valid,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "is_valid", $$v);
      },
      expression: "query.is_valid"
    }
  }), _c('b-form-select', {
    staticClass: "mr-3",
    staticStyle: {
      "max-width": "160px",
      "height": "35px",
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-advanced-search",
      modifiers: {
        "collapse-advanced-search": true
      }
    }],
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify mt-1 mr-1"
  }), _vm._v("進階搜尋 ")])], 1), _c('b-collapse', {
    staticClass: "mb-2",
    attrs: {
      "id": "collapse-advanced-search"
    },
    model: {
      value: _vm.isAdvancedSearchVisible,
      callback: function callback($$v) {
        _vm.isAdvancedSearchVisible = $$v;
      },
      expression: "isAdvancedSearchVisible"
    }
  }, [_c('b-card', [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "分店",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabled_branch_select
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "通路",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "領取方式",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.takeTypes
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.take_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "take_type", $$v);
      },
      expression: "query.take_type"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置條件")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入優惠券名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.redeemCodeBundles,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "cell(img_url)",
      fn: function fn(data) {
        return [data.item.img_url ? _c('b-img-lazy', {
          staticClass: "rounded-0",
          staticStyle: {
            "width": "100px",
            "height": "50px"
          },
          attrs: {
            "src": data.item.img_url,
            "alt": "圖片"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(start_at_and_end_at)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(_vm._s(_vm.formatDate(data.item.start_at)) + " ~")]), _c('div', [_vm._v(_vm._s(_vm.formatDate(data.item.end_at)))])];
      }
    }, {
      key: "cell(branch_id)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.getBranchName(data.item.branch_id)))])];
      }
    }, {
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "d-inline-block",
          attrs: {
            "id": "show-qrcode-wrapper-".concat(data.item.id),
            "tabindex": "0"
          }
        }, [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "id": "show-qrcode-".concat(data.item.id),
            "variant": "inverse-dark",
            "disabled": data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.URL_TAKE && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT
          },
          on: {
            "click": function click($event) {
              return _vm.showAssignUrlModal(data.item);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-link ml-2"
        })])], 1), data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.URL_TAKE && data.item.take_type !== _vm.consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT ? _c('b-tooltip', {
          attrs: {
            "target": "show-qrcode-wrapper-".concat(data.item.id),
            "triggers": "hover focus",
            "title": "領取方式不支援網址領取"
          }
        }) : _vm._e(), _c('b-modal', {
          attrs: {
            "id": "assign-url-modal-".concat(data.item.id),
            "footer-class": "modal-button-group d-flex w-100 align-items-center"
          },
          scopedSlots: _vm._u([{
            key: "modal-header",
            fn: function fn(_ref) {
              var close = _ref.close;
              return [_c('div', {
                staticClass: "d-flex w-100 align-items-center justify-content-between"
              }, [_c('h5', {
                staticClass: "m-0"
              }, [_vm._v(_vm._s(data.item.name))]), _c('b-button', {
                staticClass: "text-dark p-0",
                attrs: {
                  "size": "sm",
                  "variant": "link"
                },
                on: {
                  "click": function click($event) {
                    return close();
                  }
                }
              }, [_c('svg', {
                staticStyle: {
                  "height": "20px"
                },
                attrs: {
                  "xmlns": "http://www.w3.org/2000/svg",
                  "viewBox": "0 0 320 512"
                }
              }, [_c('path', {
                attrs: {
                  "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                }
              })])])], 1)];
            }
          }, {
            key: "modal-footer",
            fn: function fn() {
              return [_c('div', {
                staticClass: "modal-button-group d-flex w-100 align-items-center",
                staticStyle: {
                  "position": "relative",
                  "min-height": "42px"
                }
              }, [_c('div', {
                staticClass: "flex-grow-1 d-flex justify-content-center"
              }, [_c('b-button', {
                attrs: {
                  "variant": "primary"
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadQRCode(_vm.assignUrl, data.item.name);
                  }
                }
              }, [_vm._v(" 下載QRCode ")])], 1), _c('b-button', {
                staticStyle: {
                  "position": "absolute",
                  "right": "0"
                },
                attrs: {
                  "variant": "danger"
                },
                on: {
                  "click": function click($event) {
                    return _vm.$bvModal.hide("assign-url-modal-".concat(data.item.id));
                  }
                }
              }, [_vm._v(" 關閉 ")])], 1)];
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("領取網址")]), _c('b-textarea', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.click",
            value: '已複製',
            expression: "'已複製'",
            modifiers: {
              "click": true
            }
          }],
          staticClass: "mt-2",
          attrs: {
            "id": "assign-url"
          },
          on: {
            "click": _vm.copyAssignUrl
          },
          model: {
            value: _vm.assignUrl,
            callback: function callback($$v) {
              _vm.assignUrl = $$v;
            },
            expression: "assignUrl"
          }
        }), _c('div', [_c('vue-qr', {
          ref: "assignQRcode",
          attrs: {
            "text": _vm.assignUrl
          }
        })], 1)], 1)]), _vm.$permissions.hasAny([_vm.consts.REDEEM_CODE_LIST_CREATE, _vm.consts.REDEEM_CODE_LIST_MODIFY]) || _vm.fromMyConsole ? _c('b-dropdown', {
          staticClass: "ml-2",
          attrs: {
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _vm.$permissions.has(_vm.consts.REDEEM_CODE_LIST_MODIFY) || _vm.fromMyConsole ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: _vm.fromMyConsole ? 'MyConsoleRedeemCodeBundleRedeemCodes' : 'RedeemCodeBundleRedeemCodes',
              params: {
                redeemCodeBundleId: data.item.id
              }
            }
          }
        }, [_vm._v(" 使用紀錄 ")]) : _vm._e(), _vm.$permissions.has(_vm.consts.REDEEM_CODE_LIST_MODIFY) && data.item.redeemcode_type !== _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.modify(data.item);
            }
          }
        }, [_vm._v(" 數量設定 ")]) : _vm._e(), _vm.$permissions.has(_vm.consts.REDEEM_CODE_LIST_CREATE) || _vm.fromMyConsole ? _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: _vm.fromMyConsole ? 'MyConsoleRedeemCodeBundleCreate' : 'RedeemCodeBundleCreate',
              query: {
                copyFromId: data.item.id
              }
            }
          }
        }, [_vm._v(" 複製 ")]) : _vm._e()], 2) : _vm._e(), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: _vm.fromMyConsole ? 'MyConsoleRedeemCodeBundleDetail' : 'RedeemCodeBundleDetail',
              params: {
                redeemCodeBundleId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]), _vm.canModifyRedeemCodeBundle ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: _vm.fromMyConsole ? 'MyConsoleRedeemCodeBundleEdit' : 'RedeemCodeBundleEdit',
              params: {
                redeemCodeBundleId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _c('span', {
          attrs: {
            "id": "soft-delete-button-".concat(data.item.id)
          }
        }, [_vm.$permissions.has(_vm.consts.REDEEM_CODE_LIST_SOFT_DELETE) || _vm.fromMyConsole ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger",
            "disabled": false === _vm.redeemCodeBundleDataModels[data.item.id].isDeletable
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item, true);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-minus-circle"
        }), _vm._v(" 刪除 ")]) : _vm._e()], 1), false === _vm.redeemCodeBundleDataModels[data.item.id].isDeletable ? _c('b-tooltip', {
          attrs: {
            "target": "soft-delete-button-".concat(data.item.id),
            "triggers": "hover",
            "title": "發布狀態為草稿或關閉時，才能刪除"
          }
        }) : _vm._e(), _c('span', {
          attrs: {
            "id": "hard-delete-button-".concat(data.item.id)
          }
        }, [_vm.$permissions.has(_vm.consts.REDEEM_CODE_LIST_DELETE) || _vm.fromMyConsole ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger",
            "disabled": false === _vm.redeemCodeBundleDataModels[data.item.id].isDeletable
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item, false);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 永久刪除 ")]) : _vm._e()], 1), false === _vm.redeemCodeBundleDataModels[data.item.id].isDeletable ? _c('b-tooltip', {
          attrs: {
            "target": "hard-delete-button-".concat(data.item.id),
            "triggers": "hover",
            "title": "發布狀態為草稿或關閉時，才能刪除"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(is_valid)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_valid ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_valid ? '生效中' : '已失效') + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [data.item.status == _vm.consts.PUBLISH_STATUS.DRAFT ? _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(" 草稿 ")]) : _vm._e(), data.item.status == _vm.consts.PUBLISH_STATUS.PUBLISHED ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" 發布 ")]) : _vm._e(), data.item.status == _vm.consts.PUBLISH_STATUS.CLOSED ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" 關閉 ")]) : _vm._e()];
      }
    }, {
      key: "cell(usage_status)",
      fn: function fn(data) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatUsageStatus(data.item))
          }
        })];
      }
    }, {
      key: "cell(take_usage_type)",
      fn: function fn(data) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatTakeUsageType(data.item))
          }
        })];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page,
      "perPageOptions": _vm.perPageOption
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modify-modal",
      "footer-class": "d-flex justify-content-center",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "mb-2",
          domProps: {
            "innerHTML": _vm._s(_vm.selectedBundle.title)
          }
        }, [_vm._v("數量調整")])];
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-end w-100"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "md",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('modify-modal');
            }
          }
        }, [_vm._v("取消")]), _c('b-button', {
          attrs: {
            "disabled": _vm.selectedBundle.limit === null || _vm.isLoading,
            "size": "md",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return _vm.submit();
            }
          }
        }, [_vm._v(" 確認送出 ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "序號",
      "label-for": "type"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.redeemCodeTypes,
      "disabled": ""
    },
    model: {
      value: _vm.selectedBundle.redeemcode_type,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "redeemcode_type", $$v);
      },
      expression: "selectedBundle.redeemcode_type"
    }
  })], 1), _vm.selectedBundle.redeemcode_type == _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.FIXED ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "固定序號",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.selectedBundle.static_redeem_code,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "static_redeem_code", $$v);
      },
      expression: "selectedBundle.static_redeem_code"
    }
  })], 1) : _vm._e(), _vm.selectedBundle.redeemcode_type == _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.RANDOM ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "隨機序號長度",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.selectedBundle.random_redeem_code_length,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "random_redeem_code_length", $$v);
      },
      expression: "selectedBundle.random_redeem_code_length"
    }
  })], 1) : _vm._e(), _vm.selectedBundle.redeemcode_type !== _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "目前數量上限",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "placeholder": "不填寫表示無限",
      "disabled": ""
    },
    model: {
      value: _vm.selectedBundle.limit,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "limit", $$v);
      },
      expression: "selectedBundle.limit"
    }
  })], 1) : _vm._e(), _vm.selectedBundle.redeemcode_type !== _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label-for": "name"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: '請先編輯數量上限，才能調整數量',
            expression: "'請先編輯數量上限，才能調整數量'",
            modifiers: {
              "hover": true
            }
          }, {
            name: "b-tooltip",
            rawName: "v-b-tooltip.html.hover.bottom",
            value: {
              customClass: 'text-left'
            },
            expression: "{ customClass: 'text-left' }",
            modifiers: {
              "html": true,
              "hover": true,
              "bottom": true
            }
          }]
        }, [_vm._v(" 調整數量 "), _c('i', {
          staticClass: "mdi mdi-help-circle-outline ml-1",
          staticStyle: {
            "color": "#6c757d"
          }
        })])];
      },
      proxy: true
    }], null, false, 2972435312)
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-radio-group', {
    staticClass: "col-6 d-flex",
    attrs: {
      "disabled": _vm.selectedBundle.limit === null
    },
    model: {
      value: _vm.selectedBundle.action,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "action", _vm._n($$v));
      },
      expression: "selectedBundle.action"
    }
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "value": 1
    }
  }, [_vm._v("增加")]), _c('b-form-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("減少")])], 1), _c('b-form-input', {
    staticClass: "col-6 d-flex",
    attrs: {
      "type": "number",
      "disabled": _vm.selectedBundle.limit === null
    },
    model: {
      value: _vm.selectedBundle.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.selectedBundle, "quantity", $$v);
      },
      expression: "selectedBundle.quantity"
    }
  })], 1)]) : _vm._e(), _vm.selectedBundle.redeemcode_type !== _vm.consts.REDEEM_CODE_BUNDLE_REDEEMCODE_TYPES.PACKAGE ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "調整後數量上限",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "value": _vm.resultQuantity,
      "disabled": ""
    }
  })], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }